import Vue from 'vue'
// import CountDown from 'FrontComponents/vue/CountDown/Index.vue'
// import AuctionDate from 'FrontComponents/vue/AuctionDate/Index.vue'
import Lang from '~/lang'
import { store } from '../../components/front/vue/store/store'

/**
 * Then you can do stuff like this:
 *
 * {{ 'javascript.title.home' | trans }}
 * {{ 'javascript.title.welcome' | trans({ name: 'Nasirou' }) }}
 */
Vue.filter('trans', (...args) => {
    return Lang.get(...args)
})

if (document.querySelector('#countdown-wrap')) {
    const CountDown = () => import(/* webpackChunkName: "assets/countdown" */ 'FrontComponents/vue/CountDown/Index.vue')

    Vue.config.productionTip = false

    new Vue({
        el: '#countdown-wrap',
        store,
        components: {
            CountDown,
        },
    })
}

if (document.querySelector('#auction-date-wrap')) {
    const AuctionDate = () => import(/* webpackChunkName: "assets/countdown" */ 'FrontComponents/vue/AuctionDate/Index.vue')

    Vue.config.productionTip = false

    new Vue({
        el: '#auction-date-wrap',
        store,
        components: {
            AuctionDate,
        },
    })
}
